(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyve-homepage-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  const container = document.querySelector('[id^="ProductTabs-"]');
  if (!container) return;

  const tabNav = document.querySelector('.product-tabs__nav');
  const tabBtns = container.querySelectorAll('.product-tabs__btn');
  const tabPanels = container.querySelectorAll('.product-tabs__panel');

  function activateTab(tab, index) {
    tabBtns.forEach((btn, i) => {
      const isActive = i === index;
      btn.classList.toggle('product-tabs__btn--active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    tabPanels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('product-tabs__panel--active', isActive);
      panel.hidden = !isActive;
    });
    
    
    const tabRect = tab.getBoundingClientRect();
    const navRect = tabNav.getBoundingClientRect();

    const offset = tabRect.left - navRect.left;
    const scrollPosition =
      tabNav.scrollLeft +
      offset -
      navRect.width / 2 +
      tabRect.width / 2;

    tabNav.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
    
  }

  tabBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => activateTab(btn, index));

    btn.addEventListener('keydown', (e) => {
      const total = tabBtns.length;
      let newIndex = index;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        newIndex = (index + 1) % total;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        newIndex = (index - 1 + total) % total;
      } else if (e.key === 'Home') {
        e.preventDefault();
        newIndex = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        newIndex = total - 1;
      }

      if (newIndex !== index) {
        tabBtns[newIndex].focus();
        activateTab(newIndex);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyve-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('.hyve-product-section');
    if (!section) return;

    const buttons = section.querySelectorAll('[data-variant-button]');
    const link = section.querySelectorAll('[data-variant-link]');
    const images = section.querySelectorAll('[data-variant-image]');
    const buyLink = section.querySelector('[data-buy-link]');
    const base = buyLink ? buyLink.dataset.base || '/?variant=' : '/?variant=';

    const setVariant = (id) => {
      images.forEach(img => {
        const active = img.dataset.variantImage === id;
        img.classList.toggle('is-active', active);
        img.setAttribute('aria-hidden', !active);
      });
      
      buttons.forEach(btn => {
        const active = btn.dataset.variantButton === id;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active);
      });
      
      // if (buyLink) {
      //   buyLink.href = base + id;
      // }
      if (buyLink) {
        const activeBtn = section.querySelector(
          `[data-variant-button="${id}"]`
        );
        if (activeBtn && activeBtn.dataset.variantLink) {
          buyLink.href = base + activeBtn.dataset.variantLink;
        }
      }
    };

    buttons.forEach(btn => {
      btn.addEventListener('click', () => setVariant(btn.dataset.variantButton));
    });

    setVariant('1');
  })();

  } catch(e) { console.error(e); }
})();
})();
